import * as Sentry from '@sentry/react';
import { type User, UserManager } from 'oidc-client-ts';

import { userManagerSettings } from '@/features/auth/config/oidc';
import { queryClient } from '@/lib/query-client';

export type UserAccessToken = string | undefined;
export type UserPid = string | undefined;

export const userManager = new UserManager(userManagerSettings);

const onUserUnloaded = () => {
  Sentry.setUser(null);
  queryClient.clear();
  window.localStorage.clear();
  window.sessionStorage.clear();
};

export const setupUserManagerEvents = async () => {
  if (import.meta.env.VITE_APP_ENV === 'localhost') return;

  const setSentryUserAsPid = (user: User) => {
    Sentry.setUser({ id: extractUserPidFromSub(user.profile.sub) });
  };

  const user = await userManager.getUser();
  if (user) {
    setSentryUserAsPid(user);
  } else {
    userManager.events.addUserLoaded(setSentryUserAsPid);
  }

  userManager.events.addUserUnloaded(onUserUnloaded);
};

setupUserManagerEvents();

export const extractUserPidFromSub = (sub: string): UserPid => {
  const [, pid] = sub.split(':');
  return pid;
};

export const getUserAccessToken = async (): Promise<UserAccessToken> => {
  const user = await userManager.getUser();
  return user?.access_token;
};

export const getUserPid = async (): Promise<UserPid> => {
  const user = await userManager.getUser();
  if (!user) return;

  return extractUserPidFromSub(user.profile.sub);
};
